<template>
  <div v-if="$auth.check()">
    <div class="row">
      <div class="col-md-12">
        <h1>Olá, {{ $auth.user().username }}</h1>
        <p class="text-subtitle-1 grey--text">Visão geral</p>
      </div>
    </div>
    <v-row>
      <v-col cols="12" sm="6" md="3" v-if="$auth.check('CONTACT_TYPE')">
        <v-card @click="go('/contact_type')" hover>
          <v-card-text class="text-center">
            <v-icon size="48" color="primary">mdi-arrow-collapse</v-icon>
            <div class="text-h4 mt-2">
              <span v-if="types !== null">{{ types }}</span>
              <v-progress-circular v-else indeterminate size="28" color="primary"></v-progress-circular>
            </div>
            <div class="text-subtitle-1">Tipos de Contato</div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3" v-if="$auth.check('CONTACT_CLIENT')">
        <v-card @click="go('/client')" hover>
          <v-card-text class="text-center">
            <v-icon size="48" color="primary">mdi-account-circle</v-icon>
            <div class="text-h4 mt-2">
              <span v-if="clients !== null">{{ clients }}</span>
              <v-progress-circular v-else indeterminate size="28" color="primary"></v-progress-circular>
            </div>
            <div class="text-subtitle-1">Clientes</div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3" v-if="$auth.check('CONTACT_CONTRACT')">
        <v-card @click="go('/contract')" hover>
          <v-card-text class="text-center">
            <v-icon size="48" color="primary">mdi-file-multiple</v-icon>
            <div class="text-h4 mt-2">
              <span v-if="contracts !== null">{{ contracts }}</span>
              <v-progress-circular v-else indeterminate size="28" color="primary"></v-progress-circular>
            </div>
            <div class="text-subtitle-1">Contratos</div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3" v-if="$auth.check('CONTACT_CONTACT')">
        <v-card @click="go('/contact')" hover>
          <v-card-text class="text-center">
            <v-icon size="48" color="primary">mdi-phone</v-icon>
            <div class="text-h4 mt-2">
              <span v-if="contacts !== null">{{ contacts }}</span>
              <v-progress-circular v-else indeterminate size="28" color="primary"></v-progress-circular>
            </div>
            <div class="text-subtitle-1">Contatos</div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import api from "../api/index.js";
import router from "../router/index.js";
export default {
  data: function () {
    return {
      clients: null,
      contracts: null,
      types: null,
      contacts: null,
      loaded: false,
    };
  },
  computed: {
    // Reativo: vira true quando o $auth.remember() do App.vue popula user/permissions.
    ready: function () {
      return this.$auth.check();
    },
  },
  watch: {
    ready: {
      immediate: true,
      handler: function (value) {
        // Só carrega os contadores quando o login estiver pronto, e apenas uma vez.
        if (value && !this.loaded) {
          this.loaded = true;
          this.loadCounters();
        }
      },
    },
  },
  methods: {
    go: function (path) {
      router.push({ path: path });
    },
    loadCounters: function () {
      if (this.$auth.check("CONTACT_CLIENT")) {
        this.loadClients();
      }
      if (this.$auth.check("CONTACT_CONTRACT")) {
        this.loadContracts();
      }
      if (this.$auth.check("CONTACT_TYPE")) {
        this.loadTypes();
      }
      if (this.$auth.check("CONTACT_CONTACT")) {
        this.loadContacts();
      }
    },
    loadClients: function () {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/client/count", {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.clients = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    loadContracts: function () {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/contract/count", {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.contracts = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    loadTypes: function () {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/contact_type", {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.types = response.data.length;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    loadContacts: function () {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/contact/status/1", {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.contacts = response.data.length;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
